export default __webpack_public_path__ + "images/9870d92f394ec74bb9665b19a8b05f62-plane-straight.png";